export enum Toggles {
    MicrosoftClarity = 'sso-microsoft-clarity',
    AppleSignIn = 'apple-sign-in-sso',
    MobileAllowedSocialLogin = 'mobile-toggle-allowed-social-login'
}
